import { useEffect, useState } from 'react';
import type { AuthMe } from '@cornerstone/shared';
import { API_BASE } from '../client/config';

// =============================================================================
// H9(HNINE 사내 운영) 게이트.
//
// 외부 연동(Chat·Calendar)·공지 관리는 HNINE 사내 운영 도구다(HNBL-217). 백엔드가
// 쓰기를 requireHnine 으로 강제하므로 FE는 메뉴 노출만 판정한다:
//   • @hnine.com 계정        → allowed
//   • email == null(로컬 dev, AUTH off) → allowed (기존 MediaSection 관례 유지)
//   • 그 외 조직 계정        → denied
//   • 네트워크 실패          → denied(fail-closed)
// =============================================================================

export type HnineGate = 'checking' | 'allowed' | 'denied';

export function useHnineGate(): HnineGate {
  const [gate, setGate] = useState<HnineGate>('checking');

  useEffect(() => {
    const ac = new AbortController();
    fetch(`${API_BASE}/api/auth/me`, { signal: ac.signal })
      .then((r) => (r.ok ? (r.json() as Promise<AuthMe | null>) : null))
      .then((me) => {
        if (ac.signal.aborted) return;
        const email = me?.email?.toLowerCase() ?? null;
        // 플랫폼 관리자 예외 — 도메인 밖 지정 계정(운영 대행)도 H9 섹션 허용.
        // 서버측 requireHnine(PLATFORM_ADMIN_EMAILS)과 목록을 맞춰 유지할 것.
        const platformAdmin =
          email === 'beomseok.jang@hnine.com' || email === 'h9interaction@gmail.com';
        // BO 운영자(bo_operators, /me.adminRole === 'h9_super')도 허용 — 서버가 판정한 값이라 도메인보다 정확하다.
        // dev:roles의 h9@dev.local 같은 운영자 계정이 H9 메뉴는 보이는데 들어가면 튕기던 문제(2026-09-15).
        const boOperator = me?.adminRole === 'h9_super';
        setGate(
          me !== null && (email == null || email.endsWith('@hnine.com') || platformAdmin || boOperator)
            ? 'allowed'
            : 'denied',
        );
      })
      .catch(() => {
        if (!ac.signal.aborted) setGate('denied');
      });
    return () => ac.abort();
  }, []);

  return gate;
}
